import React from "react";
import ArrobaBalanceContainer from "../../balancoDeArroba/views/arrobaBalanceContainer";
import CategoryContainer from "../../category/views/categoryContainer";
import ConciliationContainer from "../../conciliacao/views/conciliationContainer";
import MovementsContainer from "../../movements/views/movementsContainer";
import { HerdControlTabs } from "../utils/herdControl.utils";

type HerdControlTabsContentProps = {
  selectedTab: HerdControlTabs;
};

function HerdControlTabsContent({ selectedTab }: HerdControlTabsContentProps) {
  if (selectedTab === HerdControlTabs.ANIMAL_CATEGORY) {
    return <CategoryContainer showConciliationAmount={true} />;
  }

  if (selectedTab === HerdControlTabs.ENTRIES_AND_EXITS) {
    return <MovementsContainer />;
  }

  if (selectedTab === HerdControlTabs.CONCILIATION) {
    return <ConciliationContainer />;
  }

  if (selectedTab === HerdControlTabs.ARROBA_BALANCE) {
    return <ArrobaBalanceContainer />;
  }

  return null;
}

export default HerdControlTabsContent;
